export enum NumberOfParticipantsDropdownDataHooks {
  DROPDOWN = 'number-of-participants-dropdown',
  OPTION_PRICE = 'number-of-participants-dropdown-option-price',
}
